export const data = [
  {
    id: 1,
    title: "Fish",
    summary: "remote island in Africa with unique biodiversity",
    description: "Tektronix RM565 Oscilloscope",
    pathToModel: "./assets/models/tektronix_rm565_oscilloscope/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": 6.61,
      "y": 0.89,
      "z": 1.37
    },
    "lookAt": {
      "x": 7.37,
      "y": 0.27,
      "z": 0.36
    }
  },
  {
    id: 2,
    title: "Treasury",
    summary: "Secret Treasury",
    description: "A place or location where treasure, such as currency or precious items are kept",
    pathToModel: "./assets/models/epson__wacom_laptop/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": 7.13,
      "y": 0.33,
      "z": 1.98
    },
    "lookAt": {
      "x": 8.32,
      "y": 2.71,
      "z": 1.33
    }
  },
  {
    id: 3,
    title: "Strange sea weed",
    summary: "Strange sea weed",
    description: "The Osborne 1 is the first commercially successful portable microcomputer, released on April 3, 1981 by Osborne Computer Corporation.",
    pathToModel: "./assets/models/osborne_dual_monitor_computer/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": 7.13,
      "y": 0.15,
      "z": 0.66
    },
    "lookAt": {
      "x": 5.78,
      "y": 0.89,
      "z": 0.68
    }
  },
  {
    id: 4,
    title: "Something flying",
    summary: "Something flying",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": 13.05,
      "y": 0.35,
      "z": 5.06
    },
    "lookAt": {
      "x": 11,
      "y": 0.7,
      "z": 3.42
    }
  },
  {
    id: 5,
    title: "Floppy Disc",
    summary: "were a ubiquitous form of data storage and transfer",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": 10.13,
      "y": 0.33,
      "z": 5
    },
    "lookAt": {
      "x": 10.32,
      "y": 0,
      "z": 1.33
    }
  },
  {
    id: 6,
    title: "Floppy Disc",
    summary: "were a ubiquitous form of data storage and transfer",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": -7.13,
      "y": 4.33,
      "z": 1.98
    },
    "lookAt": {
      "x": -8.32,
      "y": 2.71,
      "z": 1.33
    }
  },
  {
    id: 7,
    title: "Floppy Disc",
    summary: "were a ubiquitous form of data storage and transfer",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": -5.13,
      "y": 4.33,
      "z": 1.98
    },
    "lookAt": {
      "x": -3.13,
      "y": -2.33,
      "z": -1.98
    }
  },
  {
    id: 8,
    title: "Floppy Disc",
    summary: "were a ubiquitous form of data storage and transfer",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": -10.05,
      "y": 0.35,
      "z": 2.06
    },
    "lookAt": {
      "x": 11,
      "y": 2.7,
      "z": 3.42
    }
  },
  {
    id: 9,
    title: "Floppy Disc",
    summary: "were a ubiquitous form of data storage and transfer",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": 3.05,
      "y": 0.35,
      "z": 5.06
    },
    "lookAt": {
      "x": 2,
      "y": 2.7,
      "z": 3.42
    }
  },
  {
    id: 10,
    title: "Floppy Disc",
    summary: "were a ubiquitous form of data storage and transfer",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": -8,
      "y": 4.35,
      "z": 5.06
    },
    "lookAt": {
      "x": -9,
      "y": 2.7,
      "z": 3.42
    }
  },
  {
    id: 11,
    title: "Floppy Disc",
    summary: "were a ubiquitous form of data storage and transfer",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": 3.05,
      "y": 4.35,
      "z": 5.06
    },
    "lookAt": {
      "x": -4,
      "y": 1.7,
      "z": 3.42
    }
  },
  {
    id: 12,
    title: "Floppy Disc",
    summary: "were a ubiquitous form of data storage and transfer",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": -3.05,
      "y": 2.35,
      "z": -1.06
    },
    "lookAt": {
      "x": -2,
      "y": 2.7,
      "z": 3.42
    }
  },
  {
    id: 13,
    title: "Floppy Disc",
    summary: "were a ubiquitous form of data storage and transfer",
    description: "First floppy discs were invented and made by IBM and had a disk diameter of 8 inches (203 mm)",
    pathToModel: "./assets/models/amiga_floppy_disk/scene.gltf",
    imgArr: ["./assets/images/oscilloscope.png"],
    "camPos": {
      "x": 1.05,
      "y": 2.35,
      "z": -1.06
    },
    "lookAt": {
      "x": 1,
      "y": 2.7,
      "z": 3.42
    }
  }
];